// Tier helpers shared across the app.

export const TIER_STYLE = {
  bronze: { color: "#CD7F32", bg: "rgba(205,127,50,0.12)", border: "rgba(205,127,50,0.45)" },
  silver: { color: "#C0C0C0", bg: "rgba(192,192,192,0.12)", border: "rgba(192,192,192,0.45)" },
  gold:   { color: "#D4AF37", bg: "rgba(212,175,55,0.12)", border: "rgba(212,175,55,0.45)" },
  ultra:  { color: "#A78BFA", bg: "rgba(167,139,250,0.14)", border: "rgba(167,139,250,0.5)" },
};

export const tierStyle = (key) =>
  TIER_STYLE[key] || { color: "#D4AF37", bg: "rgba(212,175,55,0.12)", border: "rgba(212,175,55,0.45)" };

const sorted = (tiers) => [...(tiers || [])].sort((a, b) => a.min_points - b.min_points);

export const pickTier = (tiers, lifetime) => {
  const list = sorted(tiers);
  if (list.length === 0) return null;
  let chosen = list[0];
  for (const tr of list) {
    if (lifetime >= tr.min_points) chosen = tr;
  }
  return chosen;
};

export const nextTier = (tiers, lifetime) => {
  const list = sorted(tiers);
  return list.find((tr) => tr.min_points > lifetime) || null;
};
